import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S4};
`;

const VerificationText = styled.p`
  ${({ theme }) => theme.fontSize.M14};
  color: ${({ theme }) => theme.colors.GREY_DARK};
`;

const VerificationButton = styled.button`
  ${({ theme }) => theme.fontSize.M14};
  cursor: pointer;
  color: ${({ theme }) => theme.colors.GREY_DARK};
  border-bottom: 1px dashed ${({ theme }) => theme.colors.GREY_DARK};
  padding: 0;
`;

export { Container, VerificationButton, VerificationText };
